import { authConfig } from "../apiConfig";

export const reset_Password = async (data) => {
  try {
    const response = await authConfig.post(`changePassword`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};
// FOR PRIVILEGED USER CAN CHNAGE THE PASSWORD FOR OTHER USERS (WITHOUT CURRENT PASSWORD)
export const Password_reset = async (data) => {
  try {
    const response = await authConfig.post(`passwordReset`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};